import { mdiFormatText } from '@lumapps/lumx/icons';
import type { ConnectedWidgetProps } from '@lumapps/widget-base/components/Widget/ConnectedWidget';

import type { LegacyWidgetContributionProps } from './type';

export const WIDGET_CONTRIBUTION_TYPE = 'contribution';

export const BLOCK_STRUCTURED_CONTENT_CLASSNAME = 'block-structured-content';

export const WIDGET_CONTRIBUTION_ICON = mdiFormatText;

/**
 * Excluding `richText` from the queryKey because we don't want to re-fetch the widget in designer each time we update
 */
export const EXCLUDED_QUERY_KEY_WIDGET_PROPERTIES: ConnectedWidgetProps<LegacyWidgetContributionProps>['excludedQueryKeyWidgetProperties'] =
    ['richText'];
